import PropTypes from "prop-types";
import { CustomContainer } from "../../DependencyHelper";
import PageHeading from "../../pageHeading/PageHeading";
import PageDescription from "../../pageDescription/PageDescription";
import styles from "./FormHeading.module.scss";

const FormHeading = ({
  className,
  headingClassName,
  descClassName,
  title,
  desc,
  id,
}) => {
  return (
    <CustomContainer className={`${className} ${styles["top-wrapper"]}`}>
      <PageHeading
        text={title}
        className={`${headingClassName} ${styles["top-wrapper__heading"]}`}
        id={`${id}-heading`}
      />
      {desc && (
        <PageDescription
          text={desc}
          className={`${descClassName} ${styles["top-wrapper__desc"]}`}
          id={`${id}-desc`}
        />
      )}
    </CustomContainer>
  );
};

FormHeading.propTypes = {
  className: PropTypes.string,
  headingClassName: PropTypes.string,
  descClassName: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  id: PropTypes.string,
};

FormHeading.defaultProps = {
  className: "",
  title: "",
  desc: "",
  id: "form-heading",
};

export default FormHeading;
